import React from 'react';
import Icon from '../../../components/AppIcon';

const ReportStatistics = ({ referrals, allReferrals }) => {
  const totalReferrals = referrals?.length || 0;
  const completedReferrals = referrals?.filter(r => r?.status === 'completed')?.length || 0;
  const pendingReferrals = referrals?.filter(r => ['new', 'reviewed']?.includes(r?.status))?.length || 0;
  
  // Calculate average response time (from submission to first review)
  const reviewedReferrals = referrals?.filter(r => r?.reviewedAt);
  const avgResponseTime = reviewedReferrals?.length > 0
    ? reviewedReferrals?.reduce((sum, ref) => {
        const submissionTime = new Date(ref?.submissionDate)?.getTime();
        const reviewTime = new Date(ref?.reviewedAt)?.getTime();
        return sum + (reviewTime - submissionTime);
      }, 0) / reviewedReferrals?.length / (1000 * 60 * 60) // Convert to hours
    : 0;

  // Calculate monthly performance (current month vs all time)
  const now = new Date();
  const currentMonthStart = new Date(now?.getFullYear(), now?.getMonth(), 1);
  const currentMonthReferrals = allReferrals?.filter(r => 
    new Date(r?.submissionDate) >= currentMonthStart
  )?.length || 0;

  const stats = [
    {
      label: 'Adressages traités',
      value: totalReferrals,
      icon: 'FileText',
      color: 'blue',
      bgColor: 'bg-blue-500/10',
      textColor: 'text-blue-400',
      borderColor: 'border-blue-500/30'
    },
    {
      label: 'Cas terminés',
      value: completedReferrals,
      icon: 'CheckCircle',
      color: 'green',
      bgColor: 'bg-green-500/10',
      textColor: 'text-green-400',
      borderColor: 'border-green-500/30'
    },
    {
      label: 'En attente',
      value: pendingReferrals,
      icon: 'Clock',
      color: 'yellow',
      bgColor: 'bg-yellow-500/10',
      textColor: 'text-yellow-400',
      borderColor: 'border-yellow-500/30'
    },
    {
      label: 'Temps de réponse moyen',
      value: `${avgResponseTime?.toFixed(1)}h`,
      icon: 'Timer',
      color: 'purple',
      bgColor: 'bg-purple-500/10',
      textColor: 'text-purple-400',
      borderColor: 'border-purple-500/30'
    },
    {
      label: 'Ce mois-ci',
      value: currentMonthReferrals,
      icon: 'Calendar',
      color: 'indigo',
      bgColor: 'bg-indigo-500/10',
      textColor: 'text-indigo-400',
      borderColor: 'border-indigo-500/30'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className={`bg-[rgba(26,26,30,0.95)] backdrop-blur-2xl border ${stat?.borderColor} rounded-2xl p-6 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02]`}
        >
          <div className="flex items-center justify-between mb-3">
            <div className={`w-12 h-12 rounded-xl ${stat?.bgColor} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} className={stat?.textColor} />
            </div>
            <span className={`text-3xl font-bold ${stat?.textColor}`}>
              {stat?.value}
            </span>
          </div>
          <p className="text-sm font-medium text-gray-300">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default ReportStatistics;